module.exports = __webpack_public_path__ + "static/images/imgBg06.89cf74b.png";